import type { OnboardingFormVariant } from "./onboardingUpdateInput.js";

const normalise = (email: string): string => email.trim().toLowerCase();

/**
 * The email the form step starts with. A new organisation is created with the
 * signed-up user's email as its own, so for a business a stored email equal to
 * the signed-up one is the person's, not the company's: the company email
 * starts empty (Karo's v220 boards) and, left empty, is not sent, so the stored
 * one stays. A property owner's contact email starts from the stored email,
 * else the signed-up one.
 */
export function getInitialOnboardingEmail({
  variant,
  storedEmail,
  signedUpEmail,
}: {
  variant: OnboardingFormVariant;
  storedEmail: string | null | undefined;
  signedUpEmail: string | null;
}): string | null {
  const stored = storedEmail?.trim() ? storedEmail : null;
  if (variant === "property") {
    return stored ?? signedUpEmail;
  }
  if (
    stored &&
    signedUpEmail &&
    normalise(stored) === normalise(signedUpEmail)
  ) {
    return null;
  }
  return stored;
}
